var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 16.2a4 4 0 0 1 5.6 0l1.2-1.2a5.7 5.7 0 0 0-8 0l1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13a8 8 0 0 1 12 0l1.2-1.2a9.6 9.6 0 0 0-14.4 0L6 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 9.8a13.2 13.2 0 0 1 18.4 0l1.2-1.2a14.8 14.8 0 0 0-20.8 0l1.2 1.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiicon);
export default __webpack_public_path__ + "static/media/wifiicon.3985b2e2da6f19396f478754fd776064.svg";
export { ForwardRef as ReactComponent };